const sessionStorageKey = 'swym-wishlist-guest';
const guestModal = document.querySelector('[data-sw-guest-modal]');
const consentModal = document.querySelector('[data-sw-cookie-modal]');
const overlay = document.querySelector('[data-swym-modal-overlay]');

async function onSwymLoadCallback(swat) {
    document.removeEventListener('click', consentHandleButtonClick);
    let wishlistLid = await initializeList(swat);
    
    initializeGuestModal();
  
    document.addEventListener('swym:wishlist:update', updateWishlist);
    document.addEventListener('swym:wishlist:guest', handleGuest);
    document.addEventListener('click', (event) => handleButtonClick(event, swat, wishlistLid));
    
    if(window.location.pathname.includes('/products/')) {
        productPage(swat, wishlistLid);        
    }
}

async function initializeList(swat) {
    if (getLocalStorageKey('swymFetchInProgress')) {
        return new Promise((resolve) => {
            const interval = setInterval(() => {
                const list = getLocalStorageKey('swymListId');
                if (list) {
                    resolve(list);
                    clearInterval(interval);
                }
            }, 1000);
        });
    } else {
        setLocalStorageKey('swymFetchInProgress');
        return new Promise(async (resolve, reject) => {
            const lists = await fetchList(swat);

            if (lists.length) {
                setLocalStorageKey('swymListId', lists[0].lid);
                removeLocalStorageKey('swymFetchInProgress');
                resolve(lists[0].lid);
            } else {
                const list = await createList(swat);
                setLocalStorageKey('swymListId', list.lid);
                removeLocalStorageKey('swymFetchInProgress');
                resolve(list.lid);
            }
        })
    }
}

function getLocalStorageKey(key) {
    return localStorage.getItem(key);   
}

function setLocalStorageKey(key, value) {
    localStorage.setItem(key, value);
}

function removeLocalStorageKey(key) {
    localStorage.removeItem(key);
}

function fetchList(swat) {
    return new Promise((resolve) => {
        swat.fetchLists({
            callbackFn: resolve,
            errorFn: (error) => {
                console.error("Error while fetching all Lists", error);
            }
        });
    });
}

function createList(swat) {
    return new Promise((resolve) => {
        swat.createList({ "lname": "My Wishlist" }, resolve, console.error.bind(null, "Error while creating a List"));
    });
}

function fetchListCtx(swat, wishlistLid) {
    return new Promise((resolve, reject) => {
        swat.fetchListCtx(
            { "lid": wishlistLid },
            function(listContents) {
				//console.log(listContents);
                resolve(listContents);
            },
            function(onError) {
                console.log("Error fetching List contents", onError);
            }
        )
    })
};

function initializeGuestModal() {
    if(!guestModal) return;
    if(!sessionStorage.getItem(sessionStorageKey)) {
        sessionStorage.setItem(sessionStorageKey, JSON.stringify({ count: 0, expiry: null }));
    }
}

function updateWishlist(event) {
    const { detail } = event;
    const epiSet = new Set(detail.epiArr);
    const nodes = [...document.querySelectorAll(`.sw-button[data-wishlist-empi="${detail.empi}"]`)];

    nodes.forEach(node => {
        const nodeEpiSet = new Set(JSON.parse(node.dataset.wishlistEpi));
        if(Array.from(epiSet).some(epi => nodeEpiSet.has(epi))) {
            buttonState(node, detail.action);
        }
    });
}

function handleGuest() {
    const { expiry, count: oldCount } = JSON.parse(sessionStorage.getItem(sessionStorageKey));

    if(expiry && (Date.now() < expiry)) {
        return;
    }
  
    if(expiry && (Date.now() > expiry)) {
        updateGuestSessionStorage(0);
        showGuestModal();
        return;
    }

    const count = oldCount + 1;
    sessionStorage.setItem(sessionStorageKey, JSON.stringify({ count, expiry: null }));

    if(count === 5) {
        showGuestModal();
        updateGuestSessionStorage(count);
    }

    return;
}

async function handleButtonClick(event, swat, wishlistLid) {
    const button = event.target.closest('button.sw-button');
    if(!button || !wishlistLid) return;

    const empi = JSON.parse(button.dataset.wishlistEmpi);
    const epiArr = JSON.parse(button.dataset.wishlistEpi);
    const handle = button.dataset.wishlistHandle;

    if(!handle || !empi || !epiArr || !epiArr.length) return;

    const items = epiArr.map(epi => ({ du: `${window.location.origin}/products/${handle}`, empi, epi }));

    const action = button.classList.contains('sw-button--add') ? 'add' : 'remove';
    dispatchWishlistUpdate(empi, epiArr, action);

    if(action === 'add') {
        addProductsToList(swat, wishlistLid, items);
    } else {
        removeProductsFromList(swat, wishlistLid, items);
    }

    if(guestModal) {
        document.dispatchEvent(new CustomEvent('swym:wishlist:guest'));
    }
}

function dispatchWishlistUpdate(empi, epiArr, action) {
    const event = new CustomEvent('swym:wishlist:update', { detail: { action, empi, epiArr } });
    document.dispatchEvent(event);
}

// updated to batch of 10 instead of 5 as most products have between 5-10 variants
function performListAction(actionFn, listId, items, actionType, source) {
    Array.from(
        { length: Math.ceil(items.length / 10) },
        async (_, index) => {
            const start = index * 10;
            const batch = items.slice(start, start + 10);
            actionFn(
                listId, 
                batch,
                function(response) {
					// success function
					try {
						//console.log('Wishlist changed: ', response);
						const gaData = {
							//sku: sku,
							//type: type,
							//source: source,
							empi: `${response[0].empi}`,
							dt: response[0].dt,
							pr: response[0].pr,
						}
						if (actionType == 'add' && index == 0 && gtag) {
							window.ga4_update_wishlist(gaData, 'add')
						} else if (actionType == 'remove' && index == 0 && gtag) {
							window.ga4_update_wishlist(gaData, 'remove')
						}
					} catch(err) {
						console.log('Error sending add_to_wishlist ga event', err)
					}
				},
                function(error) {}
            );
        }
    );
}

async function addProductsToList(swat, listId, items, source) {
    performListAction(swat.addProductsToList.bind(swat), listId, items, 'add');
}

async function removeProductsFromList(swat, listId, items) {
    performListAction(swat.removeProductsFromList.bind(swat), listId, items, 'remove');
}

function updateGuestSessionStorage(count) {
    const expiry = Date.now() + (10 * 660 * 1000);
    sessionStorage.setItem(sessionStorageKey, JSON.stringify({ count, expiry }));
}

function buttonState(el, action) {
    const country = window.location.origin.split('.').slice(-1)[0];

    let actionDetails = {
        add: ['sw-button--remove', 'sw-button--add', country === 'fr' ? 'DANS VOTRE WISHLIST' : 'IN WISHLIST'],
        remove: ['sw-button--add', 'sw-button--remove', country === 'fr' ? 'AJOUTER À VOTRE WISHLIST' : 'ADD TO WISHLIST']
    };

	if (country === 'es') {
		actionDetails = {
			add: ['sw-button--remove', 'sw-button--add', 'EN TUS FAVORITOS'],
			remove: ['sw-button--add', 'sw-button--remove', 'AÑADIR A FAVORITOS']
		}
	}

    const [addClass, removeClass, labelText] = actionDetails[action];
    el.classList.add(addClass);
    el.classList.remove(removeClass);
    el.querySelector('.sw-button__label').textContent = labelText;
}

function showGuestModal() {
    guestModal.classList.add('sw-wishlist-modal--show');
    overlay.classList.add('overlay--show');
}

function cartWatcher(swat, wishlistLid) {
    async function fetchCart() { 
        return (await fetch('/cart.js')).json();
    }

    function cartHandler(cart = null) {
        return cart
            ? localStorage.setItem('cartWatcher', JSON.stringify(cart))
            : JSON.parse(localStorage.getItem('cartWatcher')) || { items: [] };
    }

    function findCartChanges(oldCart, newCart) {
        const oldItems = new Map(oldCart.items.map(i => [i.key, i]));

        return newCart.items.reduce((result, newItem) => {
            const oldItem = oldItems.get(newItem.key);
            const quantityDifference = newItem.quantity - (oldItem ? oldItem.quantity : 0);

            if (!oldItem || quantityDifference) {
                const item = {...newItem, quantity: Math.abs(quantityDifference)};
                result[quantityDifference > 0 ? 'added' : 'removed'].push(item);
            }

            return result;
        }, { added: [], removed: [] });
    }

    async function dispatchCartChanges() {
        const newCart = await fetchCart();
        const oldCart = cartHandler();
        const changes = findCartChanges(oldCart, newCart);

        document.dispatchEvent(new CustomEvent('cart:changed', { detail: changes }));
        cartHandler(newCart);
    }

    function observeCartChanges() {
        const cartObserver = new PerformanceObserver(entries => {
            if(entries.getEntries().find(entry => /xmlhttprequest|fetch/.test(entry.initiatorType) && /\/cart\//.test(entry.name)))
                dispatchCartChanges();
        });

        cartObserver.observe({ entryTypes: ['resource'] });
    }

    document.addEventListener('cart:changed', async e => {
        const detail = e.detail;
        const currentCart = cartHandler();
        if (!(currentCart.items.length && detail.added.length)) return;
    
        async function swymCartWatcher(swat) {
            let wishlistLid = await initializeList(swat);

            swat.fetchListCtx(
                { "lid": wishlistLid },
                function(listContents) {
                    const { id, product_id: productId } = detail.added[0];
    
                    const filteredItems = listContents.filter(item => item.empi === productId);
     
                    if(!filteredItems.length) return;
    
                    // ooi = only one item in wishlist before removal
                    const handleAndRemoveProduct = (items, ooi) =>{
                        handleProduct(items, productId, ooi);
                        removeProductsFromList(swat, wishlistLid, items);
                    } 
    
                    if(filteredItems.length === 1) {
                        const product = filteredItems.map(({empi, epi, du}) => ({empi, epi, du}));
                        handleAndRemoveProduct(product, true);
                    } else {
                        const product = filteredItems
                            .filter(item => item.epi === id)
                            .map(({empi, epi, du}) => ({empi, epi, du}));
                        handleAndRemoveProduct(product, false);
                    }
                },
                function(error) {
                    console.log('Error fetching list context ', error);
                }
            )
        }

        if(!window.SwymCallbacks) {
            window.SwymCallbacks = [];
        }

        window.SwymCallbacks.push(swymCartWatcher)
    });

    function handleProduct(items, productId, ooi) {
        if (window.location.pathname === '/pages/wishlist') {
            const productItemElement = document.querySelector(`[data-handle="wishlist-container"] [data-product-id="${productId}"]`);
            if (!productItemElement) return;

            if(ooi) {
                productItemElement.remove();
            }

            if(!ooi) {
                const nodes = document.querySelectorAll(`a[data-variantid='${items[0].epi}']`);
                nodes.forEach((node, index) => {       
                    const nextSibling = node.nextSibling;
                    const previousSibling = node.previousSibling;
                
                    if(index === 0 && nextSibling && nextSibling.textContent.includes('|')) {
                        nextSibling.parentNode.removeChild(nextSibling);
                    } else if(previousSibling && previousSibling.textContent.includes('|')) {
                        previousSibling.parentNode.removeChild(previousSibling);
                    }

                    node.parentNode.removeChild(node);
                }); 
            }
        }

        document.querySelectorAll(`.sw-button[data-wishlist-empi="${productId}"]`)
            .forEach(node => {
                const nodeEpiSet = new Set(JSON.parse(node.dataset.wishlistEpi));
                const isPresent = Array.from(new Set(items.map(({epi}) => epi))).some(epi => nodeEpiSet.has(epi));
                
                if(node.id === 'featured_product' && isPresent) {
                    buttonState(node, 'remove')
                } else if(ooi && isPresent) {
                    buttonState(node, 'remove');
                }
            });
    }

    observeCartChanges();
}

function productPage(swat, wishlistLid) {
    const featuredProductBtn = document.querySelector('.sw-button#featured_product');
    featuredProductBtn.classList.remove('sw-button--loading');
    
    const onLoad = async () => {
        const listContents = await fetchListCtx(swat, wishlistLid);
        const empi = JSON.parse(featuredProductBtn.dataset.wishlistEmpi);
        if(listContents.some(item => item.empi === empi)) {
            buttonState(featuredProductBtn, 'add');
        }
    }

    const onSelectOption = () => {
        document.querySelector('select[name="id"]').addEventListener('change', async function(e) {
            e.stopImmediatePropagation();

            const listContents = await fetchListCtx(swat, wishlistLid);
            const epi = Number(this.options[this.selectedIndex].value);  
            const exists = listContents.some(item => item.epi === epi);
            exists ? buttonState(featuredProductBtn, 'add') : buttonState(featuredProductBtn, 'remove')
            featuredProductBtn.setAttribute('data-wishlist-epi', JSON.stringify([Number(this.options[this.selectedIndex].value)]));
        })
    }

    onLoad();
    onSelectOption();
}

if(!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}

cartWatcher();
window.SwymCallbacks.push(onSwymLoadCallback);

function toggleConsentModal(isVisible) {
    consentModal.classList[isVisible ? 'add' : 'remove']('sw-wishlist-modal--show');
    overlay.classList[isVisible ? 'add' : 'remove']('overlay--show');
}

function consentHandleButtonClick(event) {
    event.stopImmediatePropagation();
    const button = event.target.closest('button.sw-button');
    
    if (button && !getConsentCookie()) {
        toggleConsentModal(true);
    }
}

function getConsentCookie() {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
        let [name, value] = cookie.trim().split('=');
        if (name === 'cookieyes-consent' && value) {
            const cookieParts = value.split(',');
            for (const part of cookieParts) {
                let [key, val] = part.trim().split(':');
                if (key === 'functional' && val === 'yes') return true;
            }
        }
    }
    return false;
}

function executeWithInterval(func, time = 1000, limit = 5000) {
    const interval = setInterval(func, time);

    setTimeout(() => {
        clearInterval(interval);
    }, limit);
}

function wishlistConsent() {
    if (!getConsentCookie() && window.location.pathname === '/pages/wishlist') {
        executeWithInterval(() => {
            const revisitConsent = document.querySelector('[data-cky-tag="revisit-consent"]');
            if (revisitConsent) {
                revisitConsent.click();
                clearInterval();
            }
        });
    }

    consentModal.querySelector('#sw-consent-yes-btn').addEventListener('click', function () {
        toggleConsentModal(false);
        document.querySelector('[data-cky-tag="revisit-consent"]').click();
    });

    consentModal.querySelector('#sw-consent-no-btn').addEventListener('click', function () {
        toggleConsentModal(false);
    });

    document.addEventListener('click', consentHandleButtonClick);
}

function initModalEvents() {
    document.querySelectorAll('.sw-wishlist-modal').forEach(modal => {
        const closeBtn = modal.querySelector('.sw-wishlist-modal__close');
        closeBtn.addEventListener('click', function() {
            closeBtn.parentNode.classList.remove('sw-wishlist-modal--show');
            overlay.classList.remove('overlay--show');
        });
    });

    if (overlay) {
        overlay.addEventListener('click', () => {
            overlay.classList.remove('overlay--show');
            document.querySelector('.sw-wishlist-modal--show').classList.remove('sw-wishlist-modal--show');
        })   
    }
}

initModalEvents();

const functionalConsentGiven = getConsentCookie();
if (!functionalConsentGiven && consentModal) {
    wishlistConsent();
}
